import { Box, Typography } from '@mui/material'
import './index.scss'

import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getCandidateCredits } from '../../../axios/api/candidate'
import { getCreditsDetails } from '../../../axios/api/dashboard'
import { setAvailableCreditsDetails } from '../../../store/slice/auth'
import { setCandidateCredits } from '../../../store/slice/candidate'
import { ROLES } from '../../../utils/constant'
import { checkUserAccess, showErrorToast } from '../../../utils/utils'
import CircularProgressBar from '../../circular-progress-bar'
import Icon from '../../icon'

const AvailableCreditsBadge = ({ useCandidateMode = null }) => {
  //Hooks
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Redux states
  const selectedWorkspace = useSelector(
    (state) => state.workspace.selectedWorkspace
  )
  const creditsDetails = useSelector((state) => state.auth.creditsDetails)

  const candidateCredits = useSelector((state) => state.candidate.credits)

  // Local states
  // const [loading, setLoading] = useState(false)

  // variables
  const canPurchasePlan = useMemo(() => {
    if (useCandidateMode) {
      return true
    } else {
      return checkUserAccess([ROLES.ADMIN])
    }
  }, [useCandidateMode])

  const credits = useMemo(() => {
    if (useCandidateMode) {
      return candidateCredits || 0
    } else {
      return creditsDetails?.availableCredits || 0
    }
  }, [useCandidateMode, creditsDetails, candidateCredits])

  const navigateToBuyCredits = useCallback(() => {
    if (canPurchasePlan) {
      navigate(
        useCandidateMode
          ? '/c/subscription?active=credit'
          : '/subscription?active=credit'
      )
    }
  }, [canPurchasePlan, navigate, useCandidateMode])

  // Handlers
  const fetchCreditsDetails = useCallback(async () => {
    if (!selectedWorkspace?.id) return

    // setLoading(true)
    const response = await getCreditsDetails(selectedWorkspace.id)
    // setLoading(false)
    if (response?.isError) {
      showErrorToast(response)
    } else {
      dispatch(setAvailableCreditsDetails(response))
    }
  }, [selectedWorkspace?.id, dispatch])

  const fetchCandidateCredits = useCallback(async () => {
    const response = await getCandidateCredits()
    if (response?.isError) {
      showErrorToast(response)
    } else {
      dispatch(setCandidateCredits(response?.credits))
    }
  }, [dispatch])

  // Effects
  useEffect(() => {
    if (useCandidateMode) {
      fetchCandidateCredits()
    } else {
      fetchCreditsDetails()
    }
  }, [fetchCreditsDetails, fetchCandidateCredits, useCandidateMode])

  return (
    <Box
      className={`available-credits-badge ${
        canPurchasePlan ? 'purchase-access' : ''
      }`}
      id="credits-info"
    >
      <Box className="available-credits-badge-container">
        <Box className="used-credit-progress" sx={{ position: 'relative' }}>
          <CircularProgressBar size={32} value={100} thickness={5} />
          <Box className="credit-available-btn">
            <Box className="credit-coin-icon">
              <Icon icon="noto:coin" />
            </Box>
            <Box
              className="add-credit-icon"
              onClick={navigateToBuyCredits}
              sx={{ cursor: canPurchasePlan ? 'pointer' : 'default' }}
            >
              <Box className="icon-wrapper">
                <Icon icon="qlementine-icons:plus-16" />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="credit-details">
          <Typography className="credit-count">{credits || 0}</Typography>
          <Typography className="credit-description">
            credits available
          </Typography>
        </Box>
      </Box>

      {/* <Box
        className={`available-credits-badge-refresh ${
          loading ? 'loading' : ''
        }`}
        onClick={fetchCreditsDetails}
      >
        <Icon
          className="refresh-icon"
          icon="humbleicons:refresh"
          fontSize="16px"
        />
      </Box> */}
    </Box>
  )
}

export default AvailableCreditsBadge
